import { Injectable, OnDestroy, inject } from '@angular/core';
import { BoelsBaseSite } from '@boels/models';
import { CultureFacade, SiteContextFacade } from '@boels/shared-state';
import {
  Observable,
  Subscription,
  combineLatest,
  filter,
  of,
  switchMap,
} from 'rxjs';
import { SchemaBuilder, socials } from '../../structured-data.model';

@Injectable()
export class OrganizationSchemaBuilder implements SchemaBuilder, OnDestroy {
  private siteContextFacade = inject(SiteContextFacade);
  private cultureFacade = inject(CultureFacade);

  subs$ = new Subscription();

  build(): Observable<any> {
    return combineLatest([
      this.siteContextFacade.getActiveBaseSiteEntity(),
      this.cultureFacade.getActiveCulture(),
    ]).pipe(
      filter(([, culture]) => !!culture),
      switchMap(([baseSite, culture]) => this.collect(baseSite, culture)),
    );
  }

  ngOnDestroy(): void {
    if (this.subs$) {
      this.subs$.unsubscribe();
    }
  }

  protected collect(baseSite: BoelsBaseSite, culture: string): Observable<any> {
    return of({
      '@context': 'https://schema.org',
      '@type': 'Organization',

      name: baseSite?.sdName,
      url: baseSite?.baseSiteUrl + '/' + culture,
      logo: baseSite?.sdLogoUrl,
      sameAs: socials.map((item) => item.url),
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: baseSite?.sdTelephone,
          contactType: 'customer service',
        },
      ],
    });
  }
}
